import { ENERGY_LABEL_COLORS } from '../../../constants/energyLabelColors';
import { formatNumber, WidgetWrapper } from '@agentselly/ui';

interface Props {
  readonly yearlyDemandCurrently: number;
  readonly yearlyDemandSanitized: number;
  readonly progressCurrently: number;
  readonly progressSanitized: number;
}

export function PartnerEnergyDemandWidget(props: Props) {
  return (
    <WidgetWrapper title="Energiebedarf pro Jahr">
      <div className="flex flex-col gap-4">
        <Progress
          label="Ihre Immobilie"
          progress={props.progressCurrently || 0}
          value={props.yearlyDemandCurrently || 0}
          unit="kWh/m²"
        />
        <Progress
          label="Nach Sanierung"
          progress={props.progressSanitized || 0}
          value={props.yearlyDemandSanitized || 0}
          unit="kWh/m²"
        />
      </div>
    </WidgetWrapper>
  );
}

function Progress(props: {
  readonly label: string;
  readonly progress: number;
  readonly value: number;
  readonly unit: string;
}) {
  const formattedValue = formatNumber(props.value);

  const levels = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
  ];
  const colors: Record<string, string> = {
    ...ENERGY_LABEL_COLORS,
  };

  const levelIndex = props.progress - 1;
  const level = levels[levelIndex];

  return (
    <div className="flex flex-wrap sm:flex-nowrap items-center w-full gap-2 sm:gap-4">
      <div className="w-full sm:w-[200px]">{props.label}</div>
      <div className="flex gap-1 w-full">
        {levels.map((lvl, idx) => (
          <div
            key={lvl}
            className="flex-1 h-4 rounded flex items-center justify-center"
            style={{
              backgroundColor: colors[lvl],
              opacity: idx <= levelIndex ? 1 : 0.3,
            }}
          >
            {lvl === level && (
              <span className="text-white text-xs font-medium">{lvl}</span>
            )}
          </div>
        ))}
      </div>
      <div className="w-24 shrink-0">
        <span className="font-bold">{formattedValue}</span>&nbsp;{props.unit}
      </div>
    </div>
  );
}
